import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubBrowseViewArticleRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-browse-view-article',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/articles/:articleId',
};
